import { useCallback, useRef, useEffect, memo } from "react"
import TWEEN from "@tweenjs/tween.js"
import { useThree, extend, useFrame } from "@react-three/fiber"
import { Vector3 } from "three"
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import { lerp } from "three/src/math/MathUtils"
import io from "socket.io-client"

import animateCamera from "../Utils/animateCamera"
import { cameraPositions } from "../../../ApartmentFinderConfig/cameraPositions"
import { useStore } from "../../../state/store"

extend({ OrbitControls })

function CameraControls() {
  const activeBlock = useStore(state => state.activeBlock)
  const currentCameraPositionID = useStore(state => state.currentCameraPositionID)
  // console.log(currentCameraPositionID)

  const cameraSettings = cameraPositions[currentCameraPositionID]
 console.log(currentCameraPositionID)

  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)

  const controls = useRef()
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const {
    camera,
    gl: { domElement }
  } = useThree()

  const animateToLookAt = useCallback(
    (destination, factor = 1.0) => {
      const { camera: position, target } = destination
      if (position && target && controls) {
        const [cx, cy, cz] = position
        const [tx, ty, tz] = target

        animateCamera(camera, controls.current, {
          position: {
            x: cx,
            y: cy,
            z: cz
          },
          target: {
            x: tx,
            y: ty,
            z: tz
          },
          duration: 1200
        })
      }
    },
    [camera]
  )

  useEffect(() => {
    animateToLookAt(cameraSettings)
    //   }
  }, [apartmentFinderActive, animateToLookAt, activeBlock, cameraSettings])

  // SOCKETS;
  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-camera", 1000)
    if (role === "recipient") {
      socket.current.on("camera", coordinates => {
        // Received instruction to move to a new position
        const { x, y, z } = coordinates.position
        // const { _x, _y, _z } = coordinates.rotation
        camera.position.x = x
        camera.position.y = y
        camera.position.z = z
        // camera.rotation.x = _x
        // camera.rotation.y = _y
        // camera.rotation.z = _z
      })
    }
  }, [url, role, camera.position, camera.rotation])

  const step = 0.04
  useFrame(({ clock, camera }) => {
    TWEEN.update()
    // if (role !== "recipient") {
    activeBlock &&
      (controls.current.target.x = lerp(
        controls.current.target.x,
        cameraPositions[`block${activeBlock}`].target[0],
        step
      ))
    activeBlock &&
      (controls.current.target.y = lerp(
        controls.current.target.y,
        cameraPositions[`block${activeBlock.charAt(0)}`].target[1],
        step
      ))
    activeBlock &&
      (controls.current.target.z = lerp(
        controls.current.target.z,
        cameraPositions[`block${activeBlock.charAt(0)}`].target[2],
        step
      ))
    // }
    // console.log("test")
    // controls.current.target.clamp(minPan, maxPan)
    // console.log(controls.current.target)
    // console.log(camera.position)
    controls.current.update()
  })

  return (
    <>
      <orbitControls
        minPan={new Vector3(0, 0, 0)}
        manPan={new Vector3(0, 0, 0)}
        enableZoom={true}
        enablePan={true}
        enableDamping={true}
        maxDistance={65000}
        minDistance={6000}
        // maxAzimuthAngle={1}
        maxPolarAngle={Math.PI / 2 - 0.35}
        // minAzimuthAngle={0.5}
        minPolarAngle={0.4}
        ref={controls}
        args={[camera, domElement]}
      />
    </>
  )
}

export default memo(CameraControls)
